import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["info", "link"]

  connect() {}

  toggle(event) {
    event.preventDefault();
    const info = event.currentTarget.closest('.item').querySelector('.additional-info');
    const link = event.currentTarget;
    const showDetails = link.dataset.showDetails;
    const hideDetails = link.dataset.hideDetails;

    if (info) {
      info.classList.toggle('hidden');
      link.textContent = info.classList.contains('hidden') ? showDetails : hideDetails;
    }
  }
}